import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import routes from '../../constants/routes';
import { getToken  } from '../../Utils/session-utils';
import { registerCard, verifoneConfig } from '../../apiCalls/card';
import { creditcardStatus } from '../../apiCalls/status';
import { getVerifoneErrorMessage } from '../../Utils/error-utils';
import { useSuccessBanner, useErrorBanner, useInfoModal } from '../common/ConfirmationViews/ConfirmationViews';
import { useReloadDialog } from './ReloadDialog';
import { useLoadingSpinner } from '../common/LoadingSpinner/LoadingSpinner';
import { Container, Typography, Divider, Box, Card, CardActions, CardContent} from '@material-ui/core';
import LockIcon from '@mui/icons-material/Lock';
import {makeStyles} from "@material-ui/core/styles";
const useStyles = makeStyles({
    subContent: {
        color: "#6D6D6E",
        fontSize: "20px ",
        fontFamily: "Whitney ",
        fontStyle: "semiBold",
    },
    staticTextField: {
        color: "#000000",
        fontFamily: "Whitney !important",
        fontSize: "16px !important",
        marginTop: "35px !important"
    },
    staticTextField2: {
        color: "#000000",
        fontFamily: "Whitney !important",
        fontSize: "16px !important",
        marginBottom: "20px !important"
    },
    alertBox: {
        borderLeft: "4px solid  #1E69D2 !important",
        marginTop: "32px !important"
    },
    lockIcon: {
        float: "left !important",
        paddingTop: "5px !important",
        paddingLeft: "13.5px !important",
        paddingRight: "13.5px !important",
        paddingBottom: "13.5px !important",
        fontSize: "1.7rem !important",
        color: "#1E69D2 !important"
    },
    alertContentCCPage: {
        fontFamily: "Whitney !important",
        fontSize: "16px !important",
        fontWeight: "bold !important"
    },
})

const CALLBACKHTML_URL = window.location.origin + '/rx-onboarding-ui/callback.html';
const VERIFONE_CREDITCARD_FORM_STYLES_URL = window.location.origin + '/rx-onboarding-ui/styles.css';
console.log(VERIFONE_CREDITCARD_FORM_STYLES_URL);

const CVVContent = () => (

<p>
    <h3>What is my CVV code?</h3>
        <p>
            <p><strong>Visa&reg;, Mastercard&reg;, and Discover&reg; cardholders:</strong><br />
            Turn your card over and look at the signature box. You should see either the entire 16-digit credit card number or just the last four digits followed by a special 3-digit code. This 3-digit code is your CVV number / Card Security Code.</p>
        </p>
        <p><strong>American Express&reg; cardholders:</strong><br />
        Look for the 4-digit code printed on the front of your card just above and to the right of your main credit card number. This 4-digit code is your Card Identification Number (CID). The CID is the four-digit code printed just above the Account Number.</p>
</p>
)
const PaymentFrame = ({history, setSpinner}) => {
    const sessionToken = getToken();
    
    const [iframeReady, setiframeReady] = useState(false);
    const [url, setUrl] = useState('');
    const [needConfig, setNeedConfig] = useState(true);  

    const [resInfo, setResInfo] = useState({
        action: 'buildForm',
        callback_url: CALLBACKHTML_URL,
        css_url: VERIFONE_CREDITCARD_FORM_STYLES_URL,
        formType:'1',
    });

    useEffect(() => {
        const onConfigSuccess = (res) => {
            setUrl(res.data.url);
            setResInfo((info) => ({
                ...info,
                hostedSecureID: res.data.hostedSecureId,
                merchPass: res.data.merchPass,
                //customer_id: res.data.customerId,
                //contract_id: res.data.contractId,
                mask_type: res.data.maskType,
                //hosted_tokenize: res.data.hostedTokenize,
                paymentType: res.data.paymentType,
                trans_type: res.data.transType,
                sessionId: res.data.sessionId,
                orderId: res.data.orderId,
                amount: res.data.amount,
                allowed_types: res.data.allowedTypes,
                collectAddress: res.data.collectAddress,
                required: res.data.required
            }));
            setSpinner(false);
            setiframeReady(true);
        };
        const onConfigError = (res) => {
            console.log("verifone config error")
            console.log(res);
            setiframeReady(true);
            history.push(routes.PATIENT_LOOKUP)
        };
        if(needConfig){
            setSpinner(true);
            verifoneConfig(sessionToken, onConfigSuccess, onConfigError)
            setNeedConfig(false)
        }
    }, [history, sessionToken, setSpinner, needConfig]);

    if (iframeReady) {

        const keys = Object.keys(resInfo);
        const params = keys.reduce(
            (str, key) => (`${str}&${key}=${resInfo[key]}`),
            ''
        );

        return (<iframe title="verifone"
            src={url + `?` + params}
            width="100%" height="850" frameBorder="0" marginHeight="0" marginWidth="0">Loading…
        </iframe>);
    } else {
        return (<p>Waiting for iframe config...</p>)
    }
}

const EnterCCDetailsPage = () => {
    const classes = useStyles();
    const history = useHistory();
    const {data} = history.location.state;
    const [SuccessBanner, openSuccessBanner] = useSuccessBanner();
    const [InfoModal, openInfoModal] = useInfoModal();
    const [ErrorBanner, openErrorBanner] = useErrorBanner();
    const [LoadingSpinner, setSpinner] = useLoadingSpinner();
    const [ReloadDialog, openReloadDialog] = useReloadDialog();

    const register = ({
        transId,
        appCode,
        name,
        ccNumber,
        ccType,
        expMonth,
        expYear,
        tokenPayment,
        address1,
        address2,
        city,
        state,
        zip,
        ...rest
        }
    ) => {
        console.log('register card response data');
        
        const cardInfo = {
            sessionToken: getToken(),
            ccToken: tokenPayment,
            ccDetailsDTO:{
                cardInfoDTO: {
                    last4Digits: ccNumber.slice(-4),
                    first6Digits: ccNumber.slice(0,6),
                    cardType: ccType,
                    expirationDate: expMonth + '/' + expYear
                },
                cardHolderInfoDTO: {
                    name: name
                },
                billingAddressDTO: {
                    street1: data.billingAddres1,
                    street2: data.billingAddres2,
                    city: data.city,
                    state: data.state,
                    zipCode: data.zipCode
                }
            }
        }
        const handleSuccess = () => {
            setSpinner(false);
            history.push(routes.CC_CONFIRMATION);
        };
        const handleError = () => {
            setSpinner(false);
            openErrorBanner(<p>
                We encountered an error and your card was not added to the system.
                You may try entering your card information again or you may contact customer service for assistance at 1-833-Meds-ARx.
            </p>);
        };
        setSpinner(true);
        registerCard(cardInfo, handleSuccess, handleError);
    }

    //Callbacks
    const whatCVV2 = () => {
        openInfoModal(<CVVContent/>);
    }

    const completeCREPayment = (response) => {
        // calls register
        register(response);
        // if registerCardSucceeds, redirect to confirmation page
    }

    const cancelCREPayment = () => {
        // the modal will probably disappear when we reload the page, so I'm just using alert for now.
        //calls status/creditcard/
        setSpinner(true);
        const sessionToken = getToken();
        const reload = (i) => {
            openReloadDialog();
            setSpinner(false);
        };
        creditcardStatus({
            patientId: '',
            errorCode: 'CRE Payment cancelled',
            errorMessage: 'CRE Payment cancelled',
            sessionToken: sessionToken
        }, reload, reload);
    }

    const creHandleDetailErrors = ( errorCode, gatewayCode, gatewayMessage ) => {
        openErrorBanner(getVerifoneErrorMessage(errorCode));
        //calls /status/creditcard/
        setSpinner(true);
        const sessionToken = getToken();
        const handleApi = (msg) => {
            console.log(msg);
            setSpinner(false);
        }
        creditcardStatus({
            patientId: '',
            errorCode: errorCode + gatewayCode,
            errorMessage: gatewayMessage,
            sessionToken: sessionToken
        },handleApi, handleApi);
    }

    useEffect(()=>{
        // lets the callbacks be visible to verifone
        window.top.cancelCREPayment = cancelCREPayment;
        window.top.completeCREPayment = completeCREPayment;
        window.top.creHandleDetailErrors = creHandleDetailErrors;
        window.top.whatCVV2 = whatCVV2;
    })

    return (
        <Container>
            <LoadingSpinner/>
            <ReloadDialog/>
            <Typography style={{fontSize: "48px",fontWeight: 400, padding: "1em 0 1rem", letterSpacing: "0.5px",
                lineHeight: "55px",
                fontFamily: '"Chronicle Text G1", "Frank Ruhl Libre", serif',
                position: "relative",
                marginBottom: "1em",
            }}>Ascension Rx Payment Details <Divider style={{borderBottom: "6px solid #B40F87", width: 40}}/></Typography>
            <Typography style={{color: "#6D6D6E ", fontSize: "24px ", fontStyle: "semiBold ", margin: "35px, 0px" , fontFamily: "Whitney"}}>Please enter your payment details. If available, use an HSA/FSA account to take full advantage of your benefits.</Typography>
 
            <Card className={classes.alertBox}>
                <CardContent>
                    <LockIcon className={classes.lockIcon}/>
                    <Typography color="text.secondary"> 
                        <span className={classes.alertContentCCPage}>
                            This page is secure and your payment information is protected. Your card details will be stored with Ascension Rx to simplify your refill process.
                        </span>
                    </Typography>
                </CardContent>
            </Card>
            <Typography className={classes.staticTextField}>All fields are required.</Typography>
            <Typography className={classes.staticTextField2}>We accept Credit, FSA, and HSA cards.</Typography>
            <SuccessBanner/>
            <InfoModal/>
            <ErrorBanner/>
            <PaymentFrame history={history} setSpinner={setSpinner} className={classes.frame}/>


        </Container>

    )

}

export default EnterCCDetailsPage;
